import transparencyExampelNone from '../../assets/transparency/example_none.png';
import transparencyExampleTotal from '../../assets/transparency/expample_total.png';
import transparencyExampleTrans from '../../assets/transparency/example_transition.png';
import { useTranslation } from 'react-i18next';

export const CfgInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('cfg.title')}</strong>
            <ul>
                <li>{t('cfg.li1')}</li>
                <li>{t('cfg.li2')}</li>
                <li>{t('cfg.li3')}</li>
            </ul>
            <p className="mt-2 mb-0">{t('cfg.example')}</p>
            <ul>
                <li>{t('cfg.ex1')}</li>
                <li>{t('cfg.ex2')}</li>
                <li>{t('cfg.ex3')}</li>
            </ul>
        </div>
    );
};

export const AspectRatioInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('aspectRatio.title')}</strong>

            <p className="mb-1 mt-1">{t('aspectRatio.desc')}</p>

            <ul>
                <li>1:1 (quadratic): 960 × 960 px</li>
                <li>16:9 (landscape): 1280 × 720 px</li>
                <li>9:16 (portrait): 720 × 1280 px</li>
                <li>4:3 (standard): 960 × 720 px</li>
            </ul>
        </div>
    );
};

export const SamplingStepsInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('samplingSteps.title')}</strong>

            <p className="mb-1 mt-1">{t('samplingSteps.desc')}</p>

            <ul>
                <li>{t('samplingSteps.range')}</li>
                <li>{t('samplingSteps.li2')}</li>
                <li>{t('samplingSteps.li3')}</li>
            </ul>
        </div>
    );
};

export const SamplerInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('sampler.title')}</strong>

            <p className="mb-0 mt-1">{t('sampler.desc')}</p>
        </div>
    );
};

export const SchedulerInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('scheduler.title')}</strong>

            <p className="mb-0 mt-1">{t('scheduler.desc')}</p>
        </div>
    );
};

export const SeedInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('seed.title')}</strong>

            <p className="mb-0 mt-1">{t('seed.desc')}</p>
        </div>
    );
};

export const NumberOfImagesInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('numImages.title')}</strong>

            <p className="mb-0 mt-1">{t('numImages.desc')}</p>
        </div>
    );
};

export const NumberOfVariationsInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('numVar.title')}</strong>

            <p className="mb-0 mt-1">{t('numVar.desc')}</p>
        </div>
    );
};

export const QualityInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('quality.title')}</strong>

            <p className="mb-1 mt-1">{t('quality.desc')}</p>

            <ul>
                <li>{t('quality.li1')}</li>
                <li>{t('quality.li2')}</li>
                <li>{t('quality.li3')}</li>
            </ul>
        </div>
    );
};

export const AiModelInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('aiModel.title')}</strong>

            <p className="mb-0 mt-1">{t('aiModel.desc')}</p>
        </div>
    );
};

export const PositiveNegativePromptInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('posNeg.title')}</strong>

            <p className="mb-1 mt-1">{t('posNeg.desc')}</p>

            <p className="mt-2 mb-0">{t('common.example')}</p>
            <ul>
                <li>Positive: A futuristic city at sunset</li>
                <li>Negative: blurry, low quality, distorted buildings</li>
            </ul>
        </div>
    );
};

export const WorkLoadInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <h5 className="mb-3">{t('workload.headline')}</h5>

            <p>{t('workload.intro')}</p>

            <hr />

            <strong>{t('workload.step1')}</strong>

            <p className="mt-2">{t('workload.step1a')}<strong>{t('common.baseImage')}</strong>{t('workload.step1b')}</p>

            <ul>
                <li>{t('workload.s1li1')}</li>

                <li>{t('workload.s1li2a')}<strong>{t('common.positivePrompt')}</strong>.
                    Example:
                    <i> "A futuristic city at sunset with neon reflections and flying cars"</i>
                </li>

                <li>{t('workload.s1li3a')}<strong>{t('common.negativePrompt')}</strong>{t('workload.s1li3b')}<i> "blurry, low quality, distorted buildings"</i>
                </li>

                <li>{t('workload.s1li4')}</li>

                <li>{t('workload.s1li5')}</li>

                <li>{t('workload.s1li6')}</li>
            </ul>

            <p>{t('workload.advanced')}</p>

            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>{t('common.thSetting')}</th>
                        <th>{t('common.thDescription')}</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>{t('aspectRatio.title')}</td>
                        <td>{t('workload.tbAspect')}</td>
                    </tr>

                    <tr>
                        <td>{t('common.samplingSteps')}</td>
                        <td>{t('workload.tbSampling')}</td>
                    </tr>

                    <tr>
                        <td>{t('common.cfgScale')}</td>
                        <td>{t('workload.tbCfg')}</td>
                    </tr>

                    <tr>
                        <td>{t('seed.title')}</td>
                        <td>{t('workload.tbSeed')}</td>
                    </tr>

                    <tr>
                        <td>{t('quality.title')}</td>
                        <td>{t('workload.tbQuality')}</td>
                    </tr>
                </tbody>
            </table>

            <hr />

            <strong>{t('workload.step2')}</strong>

            <p className="mt-2">{t('workload.step2p')}</p>

            <ul>
                <li>{t('workload.s2li1')}</li>
                <li>{t('workload.s2li2')}</li>
                <li>{t('workload.s2li3')}</li>
            </ul>

            <p>{t('workload.step2after')}</p>

            <hr />

            <strong>{t('workload.step3')}</strong>

            <p className="mt-2">{t('workload.step3p')}</p>

            <ul>
                <li>{t('workload.s3li1')}</li>

                <li>{t('workload.s3li2')}</li>

                <li>{t('workload.s3li3')}</li>

                <li>{t('workload.s3li4a')}<strong>{t('common.colorTolerance')}</strong>{t('workload.s3li4b')}</li>

                <li>{t('workload.s3li5')}</li>
            </ul>

            <hr />

            <strong>{t('workload.step4')}</strong>

            <p className="mt-2">{t('workload.step4p')}</p>

            <h6 className="mt-3">{t('workload.textLayers')}</h6>

            <ul>
                <li>{t('workload.tl1')}</li>
                <li>{t('workload.tl2')}</li>
                <li>{t('workload.tl3')}</li>
                <li>{t('workload.tl4')}</li>
            </ul>

            <h6 className="mt-3">{t('workload.imageLayers')}</h6>

            <ul>
                <li>{t('workload.il1')}</li>
                <li>{t('workload.il2')}</li>
                <li>{t('workload.il3')}</li>
                <li>{t('workload.il4')}</li>
            </ul>

            <h6 className="mt-3">{t('workload.drawingLayers')}</h6>

            <ul>
                <li>{t('workload.dl1')}</li>
                <li>{t('workload.dl2')}</li>
                <li>{t('workload.dl3')}</li>
                <li>{t('workload.dl4')}</li>
            </ul>

            <hr />

            <strong>{t('workload.step5')}</strong>

            <p className="mt-2">{t('workload.step5p')}</p>

            <ul>
                <li>{t('workload.s5li1')}</li>

                <li>{t('workload.s5li2')}</li>

                <li>{t('workload.s5li3')}</li>

                <li>{t('workload.s5li4')}</li>

                <li>{t('workload.s5li5')}</li>

                <li>{t('workload.s5li6')}</li>
            </ul>

            <p>{t('workload.s5after')}</p>

            <hr />

            <strong>{t('workload.step6')}</strong>

            <p className="mt-2">{t('workload.step6p')}</p>

            <ul>
                <li>{t('workload.s6li1')}</li>
                <li>{t('workload.s6li2')}</li>
                <li>{t('workload.s6li3')}</li>
            </ul>

            <p>{t('workload.s6after')}</p>

            <hr />

            <strong>{t('workload.step7')}</strong>

            <p className="mt-2">{t('workload.step7p')}</p>

            <ul>
                <li>{t('workload.s7li1')}</li>

                <li>{t('workload.s7li2')}</li>

                <li>{t('workload.s7li3')}</li>

                <li>{t('workload.s7li4')}</li>

                <li>{t('workload.s7li5')}</li>
            </ul>

            <p>{t('workload.aiToolsIntro')}</p>

            <ul>
                <li>{t('workload.tUpscaling')}</li>
                <li>{t('workload.tBgRemoval')}</li>
                <li>{t('workload.tExpand')}</li>
                <li>{t('workload.tObjRemoval')}</li>
                {/* <li>Pose extraction</li> */}
                <li>{t('workload.tObjExtract')}</li>
                <li>{t('workload.tPromptVar')}</li>
                <li>{t('workload.tCreativeTransform')}</li>
            </ul>

            <hr />

            <strong>{t('workload.final')}</strong>

            <p className="mt-2">{t('workload.finalp')}</p>

            <ul>
                <li>{t('workload.f1')}</li>
                <li>{t('workload.f2')}</li>
                <li>{t('workload.f3')}</li>
                <li>{t('workload.f4')}</li>
                <li>{t('workload.f5')}</li>
            </ul>

            <p className="mb-0 mt-3">{t('workload.closing')}</p>
        </div>
    );
};

export const WorkLoadCreateSettingsInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('wlCreate.title')}</strong>

            <p className="mb-1 mt-1">{t('wlCreate.p1')}</p>

            <p className="mb-2">{t('wlCreate.p2')}</p>

            <hr />

            <strong>{t('wlCreate.h1')}</strong>

            <ul>
                <li>
                    <strong>Aspect Ratio:</strong>{t('wlCreate.aspect')}</li>

                <li>
                    <strong>Quality:</strong>{t('wlCreate.quality')}</li>
            </ul>

            <hr />

            <strong>{t('wlCreate.h2')}</strong>

            <ul>
                <li>
                    <strong>{t('common.style')}</strong>{t('wlCreate.style')}</li>

                <li>
                    <strong>{t('common.cfgScaleColon')}</strong>{t('wlCreate.cfg')}</li>

                <li>{t('wlCreate.cfg2')}</li>
            </ul>

            <hr />

            <strong>{t('wlCreate.h3')}</strong>

            <ul>
                <li>
                    <strong>{t('common.samplingStepsColon')}</strong>{t('wlCreate.sampling')}</li>

                <li>{t('wlCreate.sampling2')}</li>

                <li>
                    <strong>{t('sampler.title')}</strong> and <strong>{t('scheduler.title')}</strong> influence how the AI processes the image generation internally.
                </li>
            </ul>

            <hr />

            <strong>{t('wlCreate.h4')}</strong>

            <ul>
                <li>
                    <strong>{t('common.seedColon')}</strong>{t('wlCreate.seed')}</li>

                <li>
                    <strong>{t('common.numImagesColon')}</strong>{t('wlCreate.numImages')}</li>
            </ul>

            <hr />

            <strong>{t('wlCreate.why')}</strong>

            <p className="mt-2 mb-0">{t('wlCreate.whyp')}</p>
        </div>
    )
};
export const WorkLoadPromptInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('wlPrompt.title')}</strong>

            <p className="mb-1 mt-1">{t('wlPrompt.p1')}</p>

            <hr />

            <strong>{t('wlPrompt.hPos')}</strong>

            <p className="mt-2 mb-1">{t('wlPrompt.posDesc')}</p>

            <ul>
                <li>{t('wlPrompt.posLi1')}</li>

                <li>{t('wlPrompt.posLi2')}</li>

                <li>{t('common.example')}<i> "A futuristic cyberpunk city at sunset with neon reflections and flying cars"</i>
                </li>
            </ul>

            <hr />

            <strong>{t('wlPrompt.hNeg')}</strong>

            <p className="mt-2 mb-1">{t('wlPrompt.negDesc')}</p>

            <ul>
                <li>{t('wlPrompt.negLi1')}</li>

                <li>{t('common.example')}<i> "blurry, low quality, distorted anatomy, duplicate objects"</i>
                </li>
            </ul>

            <hr />

            <strong>{t('wlPrompt.hRef')}</strong>

            <p className="mt-2 mb-1">{t('wlPrompt.refDesc')}</p>

            <ul>
                <li>{t('wlPrompt.refLi1')}</li>
            </ul>

            <hr />

            <strong>{t('aiModel.title')}</strong>

            <p className="mt-2 mb-1">{t('workload.s1li1')}</p>

            <ul>
                <li>{t('wlPrompt.modelLi1')}</li>

                <li>{t('wlPrompt.modelLi2a')}<strong> Qwen</strong>
                </li>
            </ul>

            <hr />

            <strong>{t('wlPrompt.hTools')}</strong>

            <ul>
                <li>
                    <strong>{t('common.checkPrompt')}</strong>{t('wlPrompt.check')}</li>
                <li>
                    <strong>{t('common.randomPrompt')}</strong>{t('wlPrompt.random')}</li>
            </ul>

            <hr />

            <strong>{t('wlPrompt.hTips')}</strong>

            <ul>
                <li>{t('wlPrompt.tip1')}</li>

                <li>{t('wlPrompt.tip2')}</li>

                <li>{t('wlPrompt.tip3')}</li>

                <li>{t('wlPrompt.tip4')}</li>
            </ul>

            <p className="mb-0 mt-3">{t('wlPrompt.closing')}</p>
        </div>
    )
};

export const WorkLoadEditStandardInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('wlEditStd.title')}</strong>

            <p className="mb-1 mt-1">{t('wlEditStd.p1')}</p>

            <p className="mb-2">{t('wlEditStd.p2')}</p>

            <hr />

            <strong>{t('wlEditStd.hBasic')}</strong>

            <ul>
                <li>{t('wlEditStd.b1')}</li>

                <li>{t('wlEditStd.b2')}</li>

                <li>{t('wlEditStd.b3')}</li>
                <li>{t('wlEditStd.b4')}</li>

                <li>{t('wlEditStd.b5')}</li>
            </ul>

            <hr />

            <strong>{t('wlEditStd.hTrans')}</strong>

            <p className="mt-2 mb-1">{t('wlEditStd.transDesc')}</p>

            <ul>
                <li>{t('wlEditStd.t1')}</li>

                <li>{t('wlEditStd.t2')}</li>

                <li>{t('wlEditStd.t3')}</li>

                <li>
                    <strong>{t('common.colorTolerance')}</strong>{t('wlEditStd.t4b')}</li>

                <li>{t('wlEditStd.t5')}</li>
            </ul>

            <hr />

            <strong>{t('wlEditStd.hFilters')}</strong>

            <p className="mt-2 mb-1">{t('wlEditStd.filtersDesc')}</p>

            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>{t('common.thCategory')}</th>
                        <th>{t('common.thSettings')}</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>{t('wlEditStd.rTemp')}</td>
                        <td>{t('wlEditStd.rTempD')}</td>
                    </tr>

                    <tr>
                        <td>{t('wlEditStd.rLight')}</td>
                        <td>{t('wlEditStd.rLightD')}</td>
                    </tr>

                    <tr>
                        <td>{t('wlEditStd.rColor')}</td>
                        <td>{t('wlEditStd.rColorD')}</td>
                    </tr>

                    <tr>
                        <td>{t('wlEditStd.rTexture')}</td>
                        <td>{t('wlEditStd.rTextureD')}</td>
                    </tr>
                </tbody>
            </table>
            <hr />

            <strong>{t('wlEditStd.hIntegration')}</strong>

            <p className="mt-2 mb-0">{t('wlEditStd.integrationP')}</p>

            <p className="mt-2 mb-0"><i>{t('wlEditStd.note')}</i></p>
            <p>{t('wlEditStd.noteP')}</p>
        </div>
    )
};
export const TemperatureInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('temperature.title')}</strong>

            <p className="mb-0 mt-1">{t('temperature.desc')}</p>
        </div>
    );
};

export const TintInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('tint.title')}</strong>

            <p className="mb-0 mt-1">{t('tint.desc')}</p>
        </div>
    );
};

export const BrightnessInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('brightness.title')}</strong>

            <p className="mb-0 mt-1">{t('brightness.desc')}</p>
        </div>
    );
};

export const ContrastInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('contrast.title')}</strong>

            <p className="mb-0 mt-1">{t('contrast.desc')}</p>
        </div>
    );
};

export const HighlightsInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('highlights.title')}</strong>

            <p className="mb-0 mt-1">{t('highlights.desc')}</p>
        </div>
    );
};

export const ShadowsInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('shadows.title')}</strong>

            <p className="mb-0 mt-1">{t('shadows.desc')}</p>
        </div>
    );
};

export const WhitenessInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('whiteness.title')}</strong>

            <p className="mb-0 mt-1">{t('whiteness.desc')}</p>
        </div>
    );
};

export const SaturationInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('saturation.title')}</strong>

            <p className="mb-0 mt-1">{t('saturation.desc')}</p>
        </div>
    );
};

export const VibranceInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('vibrance.title')}</strong>

            <p className="mb-0 mt-1">{t('vibrance.desc')}</p>
        </div>
    );
};

export const SharpnessInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('sharpness.title')}</strong>

            <p className="mb-0 mt-1">{t('sharpness.desc')}</p>
        </div>
    );
};

export const ClarityInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('clarity.title')}</strong>

            <p className="mb-0 mt-1">{t('clarity.desc')}</p>
        </div>
    );
};

export const VignettingInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('vignetting.title')}</strong>

            <p className="mb-0 mt-1">{t('vignetting.desc')}</p>
        </div>
    );
};

export const WorkLoadEditAIModeInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('wlAi.title')}</strong>

            <p className="mt-2">{t('wlAi.p1')}</p>

            <hr />

            <strong>{t('wlAi.hVar')}</strong>

            <ul>
                <li>{t('wlAi.v1')}</li>
                <li>{t('wlAi.v2')}</li>
                <li>{t('wlAi.v3')}</li>
                <li>{t('wlAi.v4')}</li>
            </ul>

            <hr />

            <strong>{t('wlAi.hEnh')}</strong>

            <ul>
                <li>{t('wlAi.e1')}</li>
                <li>{t('wlAi.e2')}</li>
                <li>{t('wlAi.e3')}</li>
                <li>{t('wlAi.e4')}</li>
            </ul>

            <hr />

            <strong>{t('wlAi.hObj')}</strong>

            <ul>
                <li>{t('wlAi.o1')}</li>
                <li>{t('wlAi.o2')}</li>
                <li>{t('wlAi.o3')}</li>
            </ul>

            <p><i>{t('wlAi.tip')}</i></p>

            <hr />

            <strong>{t('wlAi.hRef')}</strong>

            <ul>
                <li>{t('wlAi.r1')}</li>
                <li>{t('wlAi.r2')}</li>
                <li>{t('wlAi.r3')}</li>
            </ul>

            <p className="mb-0 mt-3">{t('wlAi.closing')}</p>
        </div>
    );
};

export const AiGenerateVariationsInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('aiGenVar.title')}</strong>

            <p className="mb-1 mt-1">{t('aiGenVar.desc')}</p>

            <ul>
                <li>{t('aiGenVar.li1')}</li>
                <li>{t('aiGenVar.li2')}</li>
                <li>{t('aiGenVar.li3')}</li>
                <li>{t('aiGenVar.li4')}</li>
            </ul>
            <i>{t('common.notAvailTextDraw')}</i>
        </div>
    );
};
export const AiGeneralFunctionInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('aiGen.title')}</strong>

            <p className="mt-2 mb-2">{t('aiGen.p1')}</p>

            <hr />
            <strong>{t('common.removeBackground')}</strong>

            <ul>
                <li>{t('aiGen.rb1')}</li>
                <li>{t('aiGen.rb2')}</li>
                <li>{t('aiGen.rb3')}</li>
            </ul>

            <hr/>

            <strong>{t('common.upscale')}</strong>

            <p className="text-muted mb-1">{t('aiGen.upResLabel')}</p>

            <ul>
                <li>{t('aiGen.up1')}</li>
                <li>{t('aiGen.up2')}</li>
                <li>{t('aiGen.up3')}</li>
            </ul>

            <hr />

            <strong>{t('common.expandImage')}</strong>

            <p className="text-muted mb-1">{t('aiGen.expLabel')}</p>

            <ul>
                <li>{t('aiGen.exp1')}</li>
                <li>{t('aiGen.exp2')}</li>
                <li>{t('aiGen.exp3')}</li>
            </ul>

            {/* <hr />

            <strong>Extract Pose</strong>

            <p className="text-muted mb-1">
                Pose Detection
            </p>

            <ul>
                <li>Detects and extracts the visible body pose from an image.</li>
                <li>Useful as a reference for new generations or character compositions.</li>
                <li>Helps preserve body positioning across multiple images.</li>
            </ul> */}
        </div>
    );
};
export const AiObjectInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('aiObj.title')}</strong>

            <p className="mt-2 mb-2">{t('aiObj.p1')}</p>

            <hr />

            <strong>{t('common.removeObject')}</strong>

            <ul>
                <li>{t('aiObj.ro1')}</li>
                <li>{t('aiObj.ro2')}</li>
                <li>{t('aiObj.ro3')}</li>
                <li>{t('aiObj.ro4')}</li>
            </ul>

            <hr />

            <strong>{t('common.extractObject')}</strong>

            <ul>
                <li>{t('aiObj.eo1')}</li>
                <li>{t('aiObj.eo2')}</li>
                <li>{t('aiObj.eo3')}</li>
                <li>{t('aiObj.eo4')}</li>
            </ul>

            <hr />

            <strong>{t('aiObj.hExtRem')}</strong>

            <ul>
                <li>{t('aiObj.er1')}</li>
                <li>{t('aiObj.er2')}</li>
                <li>{t('aiObj.er3')}</li>
                <li>{t('aiObj.er4')}</li>
            </ul>
        </div>
    );
};
export const AiExpandImageWIthVariationsInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('aiExpVar.title')}</strong>

            <p className="mb-1 mt-1">{t('aiExpVar.desc')}</p>

            <ol>
                <li>Clicking on this button will open an overlay to expand your image or a selected imagelayer. You will see the pixel amount of expanding in all dimensions.</li>
                <li>By saving the expanding a modal will open. If you agree with the current setting and prompt you can click on get variations and you will get multiple variations for the expaned area depending on the number of variations you choosed.</li>
                <li>You still can change the prompt and settings if you are not satisfied by clicking on Adjust settings. The expanded area will stay as selection. You can get your variations now by clicking on Get variaitons in the sidebar.</li>
            </ol>
            <p><i>{t('common.notAvailTextDraw')}</i></p>
            <p><strong>{t('aiExpVar.rec')}</strong></p>
            <ul>
                <li>Enter your prompt and adjust the settings befor you expand image.</li>
                <li>If you accidentilly unslected the expand area you still can select it again by using the free selection tool in the toolbar under the base image.</li>
            </ul>
        </div>
    );
};

export const AiConvertToImageInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('aiConv.title')}</strong>

            <p className="mb-1 mt-1">{t('aiConv.desc')}</p>

            <ul>
                <li>{t('aiGenVar.li1')}</li>
                <li>{t('aiConv.li2')}</li>
                <li>{t('aiConv.li3')}</li>
                <li>{t('aiConv.li4')}</li>
            </ul>
            <i>{t('aiConv.notAvail')}</i>
        </div>
    );
};

export const AiRemoveInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('aiRemove.title')}</strong>

            <p className="mb-1 mt-1">{t('aiRemove.desc')}</p>

            <ul>
                <li>
                    <strong>{t('common.objectRemovalColon')}</strong>{t('aiRemove.or')}</li>

                <li>
                    <strong>{t('common.bgRemovalColon')}</strong>{t('aiRemove.br')}</li>

                <li>{t('aiRemove.li3')}</li>

                <li>{t('aiRemove.li4')}</li>

                <li>{t('aiRemove.li5')}</li>

                <li>{t('aiRemove.li6')}</li>
            </ul>

            <i>{t('common.notAvailTextDraw')}</i>
        </div>
    );
};

export const AiExtractInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('aiExtract.title')}</strong>

            <p className="mb-1 mt-1">
                {/* or poses */}{t('aiExtract.desc')}</p>

            <ul>
                <li>
                    <strong>{t('common.objExtractionColon')}</strong>{t('aiExtract.oe')}</li>

                <li>{t('aiExtract.li2')}</li>
                {/* <li>
                    <strong>Pose Extraction:</strong> Extracts the pose and body structure from an image.
                </li>

                <li>
                    Extracted poses can be reused as references for future AI generations.
                </li>

                <li>
                    Helpful for recreating compositions, character positions or movement styles.
                </li> */}

                <li>{t('aiExtract.li3')}</li>
            </ul>

            <i>{t('common.notAvailTextDraw')}</i>
        </div>
    );
};

export const AiUpscaleInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('common.upscale')}</strong>
            <p><i>{t('aiUp.tip')}</i></p>


            <p className="mb-1 mt-1">{t('aiUp.desc')}</p>

            <ul>
                <li>{t('aiUp.li1')}</li>
                <li>{t('aiUp.li2')}</li>
            </ul>
            <i>{t('common.notAvailTextDraw')}</i>
        </div>
    );
};

export const AiSpellCorrectionInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('aiSpell.title')}</strong>

            <p className="mb-1 mt-1">{t('aiSpell.desc')}</p>

            <ul>
                <li>{t('aiSpell.li1')}</li>
                <li>{t('aiSpell.li2')}</li>
            </ul>
            <i>{t('aiSpell.onlyText')}</i>
        </div>
    );
};

export const ControllInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('controls.title')}</strong>

            <p className="mb-1 mt-1">{t('controls.intro')}</p>

            <hr />

            <strong>{t('controls.hSel')}</strong>

            <ul>
                <li><strong>Escape:</strong>{t('controls.escape')}</li>
            </ul>

            <hr />

            <strong>{t('controls.hNav')}</strong>

            <ul>
                <li><strong>Ctrl / Cmd + 0:</strong>{t('controls.zoomReset')}</li>
                <li><strong>Ctrl / Cmd + Plus:</strong>{t('controls.zoomIn')}</li>
                <li><strong>Ctrl / Cmd + Minus:</strong>{t('controls.zoomOut')}</li>
                <li><strong>Hold Mouse Wheel + Move Mouse:</strong>{t('controls.pan')}</li>
            </ul>
            <hr />

            <strong>{t('controls.hExport')}</strong>

            <ul>
                <li><strong>Ctrl / Cmd + S:</strong>{t('controls.exportPng')}</li>
            </ul>
            <hr />

            <strong>{t('controls.hLayerActions')}</strong>

            <ul>
                <li><strong>Ctrl / Cmd + Z:</strong>{t('controls.undo')}</li>
                <li><strong>Ctrl / Cmd + Y:</strong>{t('controls.redo')}</li>
                <li><strong>Ctrl / Cmd + Shift + Z:</strong>{t('controls.redoAlt')}</li>
                <li><strong>Ctrl / Cmd + Alt + R:</strong>{t('controls.resetLayer')}</li>
                <li><strong>Delete / Backspace:</strong>{t('controls.delete')}</li>
                <li><strong>Ctrl / Cmd + D:</strong>{t('controls.duplicate')}</li>
                <li><strong>Ctrl / Cmd + C:</strong>{t('controls.copy')}</li>
                <li><strong>Ctrl / Cmd + V:</strong>{t('controls.paste')}</li>
                <li><strong>W / A / S / D + Arrow Keys:</strong>{t('controls.resize')}</li>
            </ul>
            <hr />
            <strong>{t('controls.hPrecise')}</strong>

            <ul>
                <li><strong>Arrow Keys:</strong>{t('controls.move1')}</li>
                <li><strong>Shift + Arrow Keys:</strong>{t('controls.move10')}</li>
                <li><strong>Hold Mouse Wheel + Move Mouse:</strong>{t('controls.moveAll')}</li>
                <li><strong>Shift + Arrow Keys:</strong>{t('controls.step10')}</li>
            </ul>

            <hr />
            <strong>Layer Resize handling:</strong>{t('controls.hResizeHandling')}<ul>
                <li>{t('controls.cTL')}</li>
                <li>{t('controls.cBL')}</li>
                <li>{t('controls.cBR')}</li>
                <li>{t('controls.cTR')}</li>
            </ul>
            <hr/>

            <strong>{t('controls.hLayerSel')}</strong>
                <li><strong>Ctrl / Cmd + Shift + M:</strong>{t('controls.merge')}</li>
                <li><strong>Ctrl / Cmd + Alt + B:</strong>{t('controls.writeBase')}</li>
                <li><strong>Ctrl / Cmd + Shift + H:</strong>{t('controls.hide')}</li>
                <li><strong>Ctrl / Cmd + Alt + Shift + H:</strong>{t('controls.hideAll')}</li>
                <li><strong>Ctrl / Cmd + Alt + Shift + U:</strong>{t('controls.showAll')}</li>
                <li><strong>Ctrl / Cmd + A:</strong>{t('controls.selectAll')}</li>
                <li><strong>Ctrl / Cmd + Shift + A:</strong>{t('controls.clearSel')}</li>
            <hr />

            <strong>{t('controls.hArea')}</strong>

            <ul>
                <li><strong>Ctrl / Cmd + C:</strong>{t('controls.areaCopy')}</li>
                <li><strong>Ctrl / Cmd + V:</strong>{t('controls.areaPaste')}</li>
                <li><strong>Shift + Delete / Backspace:</strong>{t('controls.areaExtract')}</li>
            </ul>

            <hr />

            <strong>{t('controls.hRotate')}</strong>

            <ul>
                <li><strong>Ctrl / Cmd + R:</strong>{t('controls.rotateOpen')}</li>
                <li><strong>Arrow Left / Arrow Right:</strong>{t('controls.rotate1')}</li>
                <li><strong>Shift + Arrow Left / Right:</strong>{t('controls.rotate5')}</li>
                <li><strong>Enter:</strong>{t('controls.rotateSave')}</li>
            </ul>

            <hr />

            <strong>{t('controls.hCrop')}</strong>

            <ul>
                <li><strong>Ctrl / Cmd + Alt + C:</strong>{t('controls.cropOpen')}</li>
                <li><strong>W / A / S / D + Arrow Keys:</strong>{t('controls.cropAdjust')}</li>
                <li><strong>Enter:</strong>{t('controls.cropSave')}</li>
            </ul>

            <hr />

            <strong>{t('controls.hExpand')}</strong>
            <ul>
                <li><strong>Ctrl / Cmd + Alt + Shift + E:</strong>{t('controls.expTrans')}</li>
                <li><strong>Alt + V:</strong>{t('controls.expVar')}</li>
                <li><strong>W / A / S / D + Arrow Keys:</strong>{t('controls.expAdjust')}</li>
                <li><strong>Enter:</strong>{t('controls.expConfirm')}</li>
            </ul>
            <hr/>

            <strong>{t('controls.hFlip')}</strong>

            <ul>
                <li><strong>Ctrl / Cmd + F, then Arrow Left / Right:</strong>{t('controls.flipH')}</li>
                <li><strong>Ctrl / Cmd + F, then Arrow Up / Down:</strong>{t('controls.flipV')}</li>
            </ul>
        </div>
    );
};

export const TransparencyInfoElement = () => {
    const { t } = useTranslation('infotexts');
    return (
        <div>
            <strong>{t('transp.title')}</strong>

            <p className="mt-2 mb-2">{t('transp.p1a')}<strong>{t('transp.alphaValue')}</strong>{t('transp.p1b')}</p>

            <ul>
                <li>
                    <strong>{t('common.alphaColon')}</strong>{t('transp.alphaDef')}<ul>
                        <li><strong>0</strong>{t('transp.alpha0')}</li>
                        <li><strong>100</strong>{t('transp.alpha100')}</li>
                    </ul>
                </li>

                <li>
                    <strong>{t('transp.selColor')}</strong>{t('transp.selColorDef')}</li>

                <li>
                    <strong>{t('transp.colorRange')}</strong>{t('transp.colorRangeDef')}</li>
            </ul>

            <hr />

            <strong>{t('transp.hTotal')}</strong>

            <p className="mt-2 mb-2">{t('transp.totalA')}<strong>{t('common.colorRangeWord')}</strong>{t('transp.totalB')}<strong>{t('common.alphaWord')}</strong>{t('transp.totalC')}</p>

            <hr />

            <strong>{t('transp.hTransition')}</strong>

            <p className="mt-2 mb-2">{t('transp.transDesc')}</p>

            <ul>
                <li>{t('transp.tr1a')}<strong>{t('common.alphaWord')}</strong>.
                </li>

                <li>{t('transp.tr2a')}<strong>{t('common.colorRangeWord')}</strong>{t('transp.tr2b')}</li>

                <li>{t('transp.tr3')}</li>
            </ul>

            <hr />

            <strong>{t('transp.hExample')}</strong>
            <div className='row mb-1'>
                <div className='col-auto'>{t('transp.settings')}</div>
                <div className='col-auto'>
                    <i>Alpha: 0</i>
                </div>
                <div className='col-auto'>
                    <i>Color Range: 40</i>
                </div>
                <div className='col-auto'>{t('transp.exColor')}</div>
                <div className='col'>
                    <div
                        className="rounded-circle border border-secondarym-0"
                        title='Color: rgb(74,186,195)'
                        style={{
                            width: 20,
                            height: 20,
                            backgroundColor: "rgb(74,186,195)"
                        }}
                    />
                </div>
            </div>         

            <div className="row g-2">
                <div className="col-4 text-center">
                    <img
                        src={transparencyExampelNone}
                        alt="Original"
                        className="img-fluid rounded border"
                    />
                    <small className="d-block mt-1">{t('transp.exOriginal')}</small>
                </div>

                <div className="col-4 text-center">
                    <img
                        src={transparencyExampleTotal}
                        alt="Total Transparency"
                        className="img-fluid rounded border"
                    />
                    <small className="d-block mt-1">{t('transp.hTotal')}</small>
                </div>

                <div className="col-4 text-center">
                    <img
                        src={transparencyExampleTrans}
                        alt="Transition Transparency"
                        className="img-fluid rounded border"
                    />
                    <small className="d-block mt-1">{t('transp.exTransition')}</small>
                </div>
            </div>
        </div>
    );
};